import React, { useState, useEffect } from 'react'
import {
  MuiSelect,
  D3VerticalStacked,
  D3Range,
  MuiButton,
  MuiButtons,
  Legend,
  DownloadExcel,
  GraphGridTab
} from '../../../../../components'
import { useGlobalStore } from '../../../../../store'
import { LEGEND_COLOR_MAP_NEW } from '../../../../../constants'
import { IconClose } from '../../../../../assets/images/iconsV2'
import {
  getDistinctValues,
  fakeDelay,
  getProgressionArray,
  toSentenceCase,
} from '../../../../../util'
import ProgressionRange from '../progressionRange'
// import GraphGridTab from '../graphGridTab'
import SentimentTable from '../sentimentTable'
import {
  PopupWrapper,
  GraphOuterWrapper,
  HeaderWrapper,
  TitleWrapper,
  Title1,
  Title2,
  Lhs,
  Rhs,
  LegendWrapper,
  StackedGraphWrapper,
  NoDataFound,
  DriverTitle,
} from './style'

const DriversProgressionPopup = ({
  popupDropdownArrayWithAllMonths,
  popupDropdownArray,
  keyOrdering,
  insightsElementType,
}) => {
  const [selectedObject, setSelectedObject] = useState({
    showGraph: true,
    lastClicked: 'none',
  })
  const [data, setData] = useState([])
  const { setDriverProgressionPopupObject } = useGlobalStore()

  const formatDate = (obj, type) => {
    return type === 'start' ? data[data.length - 1].label : data[0].label
  }

  const onChangeFunc = (obj) => {
    setSelectedObject((prev) => ({
      ...prev,
      startDate: obj.start,
      endDate: obj.end,
      progressionRangeObject: {},
      lastClicked: 'graphSlider',
    }))
  }

  const onRangeChangeFunc = (p) => {
    if (
      selectedObject?.driverValue &&
      selectedObject?.attributeValue != undefined &&
      selectedObject?.subAttributeValue != undefined &&
      p
    ) {
      let arr = popupDropdownArrayWithAllMonths
        .filter((f) => f.drivers === selectedObject.driverValue)
        .filter((f) => f.attributes === selectedObject.attributeValue)
        .filter((f) => f.subAttributes === selectedObject.subAttributeValue)

      let end = new Date(arr[0]?.otherDetails?.CreatedDate).getTime()
      let start = new Date(arr[arr.length - 1].otherDetails.CreatedDate).getTime()

      if (p?.title !== 'MAX' && p?.barsInGraph > 0) {
        const selectedRangeData = []
        const min = Math.min(keyOrdering.length, p.barsInGraph)

        for (let i = 0; i < min; i++) {
          let dummyObj = {
            label: keyOrdering[i],
            otherDetails: {
              Percent: 0,
              PositivePercent: 0,
              MixedPercent: 0,
              NeutralPercent: 0,
              NegativePercent: 0,
            },
            values: { v1: 0, v2: 0, v3: 0, v4: 0 },
          }
          if (
            [
              'SearchDriversProgression3Level',
              'DriversProgressionWithoutSentiments3Level',
            ].includes(insightsElementType)
          ) {
            dummyObj = { v1: 0 }
          }
          const obj =
            arr.filter((f) => f.label.toLowerCase() === keyOrdering[i].toLowerCase())?.[0] ||
            dummyObj
          selectedRangeData.push(obj)
        }
        arr = selectedRangeData
        end = new Date(arr[0].otherDetails.CreatedDate).getTime()
        start = new Date(arr[arr.length - 1].otherDetails.CreatedDate).getTime()
      }

      setSelectedObject((prev) => ({
        ...prev,
        startDate: start,
        endDate: end,
        progressionRangeObject: p,
        lastClicked: 'rangeButtons',
      }))
    }
  }

  const onDropdownChangeFunc = (obj) => {
    if (
      obj?.driverValue &&
      obj?.attributeValue != undefined &&
      obj?.subAttributeValue != undefined &&
      !selectedObject?.startDate &&
      !selectedObject?.endDate
    ) {
      let arr = popupDropdownArrayWithAllMonths
        .filter((f) => f.drivers === obj.driverValue)
        .filter((f) => f.attributes === obj.attributeValue)
        .filter((f) => f.subAttributes === obj.subAttributeValue)
        .filter((f) => f.otherDetails?.CreatedDate !== undefined)

      let end = new Date(arr[0]?.otherDetails?.CreatedDate).getTime()
      let start = new Date(arr[arr.length - 1].otherDetails.CreatedDate).getTime()

      setSelectedObject((prev) => ({ ...prev, ...obj, startDate: start, endDate: end }))
    } else {
      setSelectedObject((prev) => ({ ...prev, ...obj }))
    }
  }

  const showGraphFunc = (p) => {
    const obj = { ...selectedObject, showGraph: p === 'graph' }
    setSelectedObject((prev) => ({ ...prev, ...obj }))
  }

  const onClosePopup = () => {
    setSelectedObject({ showGraph: true, lastClicked: 'none' })
    setDriverProgressionPopupObject({})
  }

  useEffect(() => {
    const progressionRangeArray = getDistinctValues(
      popupDropdownArrayWithAllMonths.map((d) => ({ PeriodName: d.label })),
      'PeriodName'
    )
    const getUniqueValues = getProgressionArray(progressionRangeArray, 'popup')
    
    setSelectedObject((prev) => ({
      ...prev,
      progressionRangeArray: getUniqueValues,
      progressionRangeObject: getUniqueValues[getUniqueValues.length - 1],
    }))

    setTimeout(() => {
      setSelectedObject((prev) => ({
        ...prev,
        progressionRangeArray: getUniqueValues,
        progressionRangeObject: getUniqueValues[getUniqueValues.length - 1],
      }))
    }, 1000)
  }, [])

  useEffect(() => {
    let arr = popupDropdownArrayWithAllMonths
      .filter((f) => f.drivers === selectedObject.driverValue)
      .filter((f) => f.attributes === selectedObject.attributeValue)
      .filter((f) => f.subAttributes === selectedObject.subAttributeValue)

    if (selectedObject?.startDate && selectedObject?.endDate) {
      const getTime = (f) => {
        return new Date(f.otherDetails.CreatedDate).getTime()
      }
      const getEndDate = (originalTimestamp) => {
        // NODE: THIS IS AN IMPORTANT CHANGE
        let date = new Date(originalTimestamp)
        // date.setDate(28) // was commented as it as showing month end issue
        date.setHours(23, 59); // set hours to 23 and minutes to 59
        return Math.floor(date.getTime())
      }
      const getStartDate = (originalTimestamp) => {
        // NODE: THIS IS AN IMPORTANT CHANGE
        let date = new Date(originalTimestamp)
        date.setDate(1)
        return Math.floor(date.getTime())
      }
      // arr = arr.filter(f => (getTime(f) >= selectedObject?.startDate && getTime(f) <= selectedObject?.endDate) )
      arr = arr.filter((f) => {
        const time = getTime(f)
        return (
          time >= getStartDate(selectedObject?.startDate) &&
          time <= getEndDate(selectedObject?.endDate)
        )
      })
    }

    setData(arr)
  }, [selectedObject])

  return (
    <PopupWrapper className='popupWrapper'>
      <Header
        popupDropdownArrayWithAllMonths={popupDropdownArrayWithAllMonths}
        popupDropdownArray={popupDropdownArray}
        onDropdownChange={onDropdownChangeFunc}
        onRangeChange={onRangeChangeFunc}
        data={data}
        selectedObject={selectedObject}
        show={selectedObject.showGraph ? 'graph' : 'table'}
        setShow={(p) => showGraphFunc(p)}
        onClosePopup={() => onClosePopup()}
      />
      {selectedObject?.driverValue &&
        selectedObject?.progressionRangeObject &&
        popupDropdownArrayWithAllMonths?.length && (
          <GraphOuterWrapper>
            <TitleWrapper>
              <Title1>
                {selectedObject?.subAttributeValue ||
                  selectedObject?.attributeValue ||
                  selectedObject?.driverValue}
              </Title1>
              {data?.length > 0 && (
                <Title2>
                  From {formatDate(selectedObject, 'start')} to {formatDate(selectedObject, 'end')}
                </Title2>
              )}
            </TitleWrapper>
            {data?.length && <>
              {selectedObject.showGraph ? (
                <>
                  <GraphWrapper
                    data={data}
                    keyOrdering={keyOrdering}
                    insightsElementType={insightsElementType}
                    selectedObject={selectedObject}
                  />
                  <GraphRange
                    data={data}
                    keyOrdering={keyOrdering}
                    popupDropdownArrayWithAllMonths={popupDropdownArrayWithAllMonths}
                    selectedObject={selectedObject}
                    onChange={(e) => onChangeFunc(e)}
                  />
                  {['DriversProgression3Level'].includes(insightsElementType) && <GraphLegend />}
                </>
              ) : (
                <>
                  <SentimentTable
                    data={data}
                    selectedObject={selectedObject}
                    insightsElementType={insightsElementType}
                  />
                </>
              )}
            </>}
          </GraphOuterWrapper>
        )}
    </PopupWrapper>
  )
}

export default DriversProgressionPopup

const Header = ({
  popupDropdownArray,
  onDropdownChange,
  onRangeChange,
  data,
  selectedObject,
  show,
  setShow,
  onClosePopup
}) => {
  const { driverProgressionPopupObject, setDriverProgressionPopupObject } = useGlobalStore()
  const [driverArray, setDriverArray] = useState([])
  const [driverValue, setDriverValue] = useState({})
  const [attributeArray, setAttributeArray] = useState([])
  const [attributeValue, setAttributeValue] = useState({})
  const [subAttributeArray, setSubAttributeArray] = useState([])
  const [subAttributeValue, setSubAttributeValue] = useState({})
  const [excelData, setExcelData] = useState({})
  const [progressionRangeObject, setProgressionRangeObject] = useState(
    selectedObject?.progressionRangeObject || {}
  )

  // const onClosePopup = () => {
  //   setDriverProgressionPopupObject({})
  // }

  const getExportToExcelObject = () => {
    let excelObject = {}
    const labelArray = data.map((d) => d.label)

    if (
      driverValue?.value?.length > 0 &&
      attributeValue?.value === 'Overview' &&
      subAttributeValue?.value === 'Overview'
    ) {
      excelObject = {
        drivers: popupDropdownArray
          .filter(
            (f) =>
              f.drivers === driverValue.value &&
              f.attributes === 'Overview' &&
              f.subAttributes === 'Overview'
          )
          .filter((f) => labelArray.includes(f.label))
          .filter((d) => d?.excel?.length > 0)
          .map((d) => d.excel),
        attributes: popupDropdownArray
          .filter(
            (f) =>
              f.drivers === driverValue.value &&
              f.attributes !== 'Overview' &&
              f.subAttributes === 'Overview'
          )
          .filter((f) => labelArray.includes(f.label))
          .filter((d) => d?.excel?.length > 0)
          .map((d) => d.excel),
        subAttributes: popupDropdownArray
          .filter(
            (f) =>
              f.drivers === driverValue.value &&
              f.attributes !== 'Overview' &&
              f.subAttributes !== 'Overview'
          )
          .filter((f) => labelArray.includes(f.label))
          .filter((d) => d?.excel?.length > 0)
          .map((d) => d.excel),
      }
    } else if (
      driverValue?.value?.length > 0 &&
      attributeValue?.value !== 'Overview' &&
      subAttributeValue?.value === 'Overview'
    ) {
      excelObject = {
        drivers: popupDropdownArray
          .filter(
            (f) =>
              f.drivers === driverValue.value &&
              f.attributes === 'Overview' &&
              f.subAttributes === 'Overview'
          )
          .filter((f) => labelArray.includes(f.label))
          .filter((d) => d?.excel?.length > 0)
          .map((d) => d.excel),
        attributes: popupDropdownArray
          .filter(
            (f) =>
              f.drivers === driverValue.value &&
              f.attributes === attributeValue?.value &&
              f.subAttributes === 'Overview'
          )
          .filter((f) => labelArray.includes(f.label))
          .filter((d) => d?.excel?.length > 0)
          .map((d) => d.excel),
        subAttributes: popupDropdownArray
          .filter(
            (f) =>
              f.drivers === driverValue.value &&
              f.attributes === attributeValue?.value &&
              f.subAttributes !== 'Overview'
          )
          .filter((f) => labelArray.includes(f.label))
          .filter((d) => d?.excel?.length > 0)
          .map((d) => d.excel),
      }
    } else if (
      driverValue?.value?.length > 0 &&
      attributeValue?.value !== 'Overview' &&
      subAttributeValue?.value !== 'Overview'
    ) {
      excelObject = {
        drivers: popupDropdownArray
          .filter(
            (f) =>
              f.drivers === driverValue.value &&
              f.attributes === 'Overview' &&
              f.subAttributes === 'Overview'
          )
          .filter((f) => labelArray.includes(f.label))
          .filter((d) => d?.excel?.length > 0)
          .map((d) => d.excel),
        attributes: popupDropdownArray
          .filter(
            (f) =>
              f.drivers === driverValue.value &&
              f.attributes === attributeValue?.value &&
              f.subAttributes === 'Overview'
          )
          .filter((f) => labelArray.includes(f.label))
          .filter((d) => d?.excel?.length > 0)
          .map((d) => d.excel),
        subAttributes: popupDropdownArray
          .filter(
            (f) =>
              f.drivers === driverValue.value &&
              f.attributes === attributeValue?.value &&
              f.subAttributes === subAttributeValue?.value
          )
          .filter((f) => labelArray.includes(f.label))
          .filter((d) => d?.excel?.length > 0)
          .map((d) => d.excel),
      }
    }
    setExcelData(excelObject)
  }

  const onLoadPopup = async () => {
    await fakeDelay(500)
    if (driverProgressionPopupObject?.level_1) {
      setDriverValue({
        label: driverProgressionPopupObject.level_1,
        value: driverProgressionPopupObject.level_1,
      })
      if (driverProgressionPopupObject?.level_2) {
        await fakeDelay(50)
        setAttributeValue({
          label: driverProgressionPopupObject.level_2,
          value: driverProgressionPopupObject.level_2,
        })
        if (driverProgressionPopupObject?.level_3) {
          await fakeDelay(50)
          setSubAttributeValue({
            label: driverProgressionPopupObject.level_3,
            value: driverProgressionPopupObject.level_3,
          })
        }
      }
    }
  }

  const getUniqueValuesFunc = () => {
    const progressionRangeArray = getDistinctValues(
      popupDropdownArray.map((d) => ({ PeriodName: d.label })),
      'PeriodName'
    )
    return getProgressionArray(progressionRangeArray, 'popup')
  }

  useEffect(() => {
    const attrArr = popupDropdownArray
      .filter((f) => f.drivers === driverValue.value)
      .map((d) => d.attributes)
    const attributeArr = getDistinctValues(attrArr).map((d) => ({
      label: d === '' ? 'Overview' : d,
      value: d,
    }))

    setAttributeArray(attributeArr)
    setAttributeValue(attributeArr[0])
    setSubAttributeValue({})
    setSubAttributeArray([])

    onDropdownChange({
      driverValue: driverValue?.value,
      attributeValue: attributeValue?.value,
      subAttributeValue: subAttributeValue?.value,
    })
    // getExportToExcelObject()
  }, [driverValue])

  useEffect(() => {
    if (attributeValue?.value?.length >= 0) {
      const subAttrArr = popupDropdownArray
        .filter((f) => f.drivers === driverValue.value && f.attributes === attributeValue.value)
        .map((d) => d.subAttributes)
      const subAttributeArr = getDistinctValues(subAttrArr).map((d) => ({
        label: d === '' ? 'Overview' : d,
        value: d,
      }))

      setSubAttributeArray(subAttributeArr)
      setSubAttributeValue(subAttributeArr[0])

      onDropdownChange({
        driverValue: driverValue?.value,
        attributeValue: attributeValue?.value,
        subAttributeValue: subAttributeValue?.value,
      })
      // getExportToExcelObject()
    }
  }, [attributeValue])

  useEffect(() => {
    onDropdownChange({
      driverValue: driverValue?.value,
      attributeValue: attributeValue?.value,
      subAttributeValue: subAttributeValue?.value,
    })
    // getExportToExcelObject()
  }, [subAttributeValue])

  useEffect(() => {
    // onDropdownChange({driverValue:driverValue?.value, attributeValue:attributeValue?.value, subAttributeValue:subAttributeValue?.value})
    if (
      driverValue?.value != undefined &&
      attributeValue?.value != undefined &&
      subAttributeValue?.value != undefined
    ) {
      getExportToExcelObject()
    }
  }, [driverValue, attributeValue, subAttributeValue])

  useEffect(() => {
    onRangeChange(progressionRangeObject)
    getExportToExcelObject()
  }, [progressionRangeObject])

  useEffect(() => {
    const driver = getDistinctValues(popupDropdownArray.map((d) => d.drivers)).map((d) => ({
      label: d,
      value: d,
    }))
    setDriverArray(driver)
    setDriverValue(driver[0])
  }, [])

  useEffect(() => {
    onLoadPopup()
  }, [driverProgressionPopupObject])

  return (
    <HeaderWrapper>
      <Lhs>
        <DriverTitle>Select Driver</DriverTitle>
        {driverArray?.length && driverValue?.value && (
          <>
            <MuiSelect
              style={{ minWidth: '150px' }}
              name={'driver'}
              styletype='themeV2'
              onChange={(e) => setDriverValue({ label: e.target.value, value: e.target.value })}
              data={driverArray}
              compact
              selectlabel='label'
              selectvalue='value'
              value={driverValue.label}
              theme='theme2'
            />
          </>
        )}
        {attributeArray?.length > 0 && (
          <>
            <MuiSelect
              style={{ minWidth: '150px' }}
              name={'attribute'}
              styletype='themeV2'
              onChange={(e) => setAttributeValue({ label: e.target.value, value: e.target.value })}
              data={attributeArray}
              compact
              placeholder={attributeValue.value}
              selectlabel='label'
              selectvalue='value'
              value={attributeValue.value}
              theme='theme2'
            />
          </>
        )}
        {subAttributeArray?.length > 0 && attributeValue?.value !== 'Overview' && (
          <>
            <MuiSelect
              style={{ minWidth: '150px' }}
              name={'subAttribute'}
              styletype='themeV2'
              onChange={(e) =>
                setSubAttributeValue({ label: e.target.value, value: e.target.value })
              }
              data={subAttributeArray}
              compact
              placeholder={subAttributeValue.value}
              selectlabel='label'
              selectvalue='value'
              value={subAttributeValue.value}
              theme='theme2'
            />
          </>
        )}
      </Lhs>
      <Rhs>
        {show && <GraphGridTab show={show} onClick={(p) => setShow(p)} />}
        {popupDropdownArray && selectedObject?.progressionRangeObject && (
          <ProgressionRange
            defaultSelected={selectedObject.progressionRangeObject}
            data={getUniqueValuesFunc()}
            progressionRangeObject={progressionRangeObject}
            setProgressionRangeObject={setProgressionRangeObject}
          />
        )}
        {excelData?.drivers?.length > 0 && driverValue?.value?.length > 0 && (
          <DownloadExcel
            Title={driverValue?.value}
            downloadId={`id_${driverValue?.value?.replaceAll(' ', '')}`}
            downloadIdData={excelData}
            buttonName='Export'
            InsightsElementType={'DriversProgression3Level'}
          />
        )}
        {/* <MuiButtons buttonType='close' onClick={onClosePopup} /> */}
        <MuiButton
          variant='outlined'
          color='light'
          startIcon={<IconClose />}
          onClick={onClosePopup}
        />
      </Rhs>
    </HeaderWrapper>
  )
}

const GraphWrapper = ({ data, keyOrdering, insightsElementType }) => {
  const trimZeros = (arr) => {
    let start = arr.findIndex((obj) => obj.percent !== 0)
    let end = arr.length - 1 - [...arr].reverse().findIndex((obj) => obj.percent !== 0)
    return arr.slice(start, end + 1)
  }

  const generateMonths = (startLabel, type, count = 12) => {
    let [startMonth, startYear] = startLabel.split(' ')
    startYear = parseInt(startYear, 10) + 1

    let result = []
    if (type === 'months' || type === 'fullMonths') {
      const array =
        type === 'months'
          ? [
              'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec',
              'dec-jan', 'jan-feb', 'feb-mar', 'mar-apr', 'apr-may', 'may-jun', 'jun-jul', 'jul-aug', 'aug-sep', 'sep-oct', 'oct-nov', 'nov-dec',
            ]
          : [
              'january',
              'february',
              'march',
              'april',
              'may',
              'june',
              'july',
              'august',
              'september',
              'october',
              'november',
              'december',
            ]
      let startIndex = array.indexOf(startMonth.toLowerCase())

      for (let i = 0; i < count; i++) {
        let monthIndex = (startIndex - i + 12) % 12
        let year = startYear - (startIndex - i < 0 ? 1 : 0)
        result.push(`${toSentenceCase(array[monthIndex])} ${year.toString()}`)
      }
      result = result.reverse()
    } else if (type === 'quarter') {
      const array = ['q1', 'q2', 'q3', 'q4'].reverse()
      let startIndex = array.indexOf(startMonth.toLowerCase())

      let year = startYear - 1
      for (let i = 0; i < count; i++) {
        const monthIndex = ((startIndex - i + 12) % 12) % 4
        if (monthIndex === 3) {
          year = year + 1
        }
        result.push(`${toSentenceCase(array[monthIndex])} ${year.toString()}`)
      }
    } else if (type === 'trimester') {
      const array = ['t1', 't2', 't3'].reverse()
      let startIndex = array.indexOf(startMonth.toLowerCase())

      let year = startYear - 1
      for (let i = 0; i < count; i++) {
        const monthIndex = ((startIndex - i + 12) % 12) % 3
        if (monthIndex === 2) {
          year = year + 1
        }
        result.push(`${toSentenceCase(array[monthIndex])} ${year.toString()}`)
      }
    } else if (type === 'half') {
      const array = ['h1', 'h2'].reverse()
      let startIndex = array.indexOf(startMonth.toLowerCase())

      let year = startYear - 1
      for (let i = 0; i < count; i++) {
        const monthIndex = ((startIndex - i + 12) % 12) % 6
        if (monthIndex === 2) {
          year = year + 1
        }
        result.push(`${(array[monthIndex])} ${year.toString().replace(20, '')}`)
      }
    } else if (type === 'phase') {
      const array = ['phase1', 'phase2', 'phase3', 'phase4'].reverse()
      let startIndex = array.indexOf(startMonth.toLowerCase())

      let year = startYear - 1
      for (let i = 0; i < count; i++) {
        const monthIndex = ((startIndex - i + 12) % 12) % 4
        if (monthIndex === 3) {
          year = year + 1
        }
        result.push(`${toSentenceCase(array[monthIndex])} ${year.toString()}`)
      }
    }
    return result
  }

  // const year = new Date().getFullYear()
  const data2 = keyOrdering
    .map((d) => {
      const data3 =
        data.filter(
          (f) => f.label.toLowerCase().replaceAll(' ', '') === d.toLowerCase().replaceAll(' ', '')
        )?.[0] || {}

      const obj = {
        label: d,
        fullLabel: d,
        otherDetails: data3 || {
          Percent: 0,
          PositivePercent: 0,
          NeutralPercent: 0,
          MixedPercent: 0,
          NegativePercent: 0,
        },
        values: data3?.values || { v1: 0, v2: 0, v3: 0, v4: 0 },
        percent: data3?.otherDetails?.Percent || data3?.Percent || 0,
      }

      if (['SearchDriversProgression3Level'].includes(insightsElementType)) {
        obj.values = { v1: obj.percent || 0 }
        obj.otherDetails = {
          ...obj.otherDetails,
          SearchKeywords: obj.percent || 0,
          values: { v1: obj.percent || 0 },
        }
      } else if (['DriversProgressionWithoutSentiments3Level'].includes(insightsElementType)) {
        obj.values = { v1: obj.percent || 0 }
        obj.otherDetails = {
          ...obj.otherDetails,
          WithoutSentiments: obj.percent || 0,
          values: { v1: obj.percent || 0 },
        }
      }

      return obj
    })
    .reverse()

  let finalData = trimZeros(data2)

  const dataLength = finalData.length
  if (dataLength > 0 && dataLength < 12) {
    const lastElement = finalData[dataLength - 1]
    let array = []
    if (
      [
        'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec',
        'dec-jan', 'jan-feb', 'feb-mar', 'mar-apr', 'apr-may', 'may-jun', 'jun-jul', 'jul-aug', 'aug-sep', 'sep-oct', 'oct-nov', 'nov-dec',
      ].includes(
        lastElement.label.toLowerCase().split(' ')[0]
      )
    ) {
      array = generateMonths(lastElement.label, 'months')
    } else if (
      [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
      ].includes(lastElement.label.toLowerCase().split(' ')[0])
    ) {
      array = generateMonths(lastElement.label, 'fullMonths')
    } else if (['q1', 'q2', 'q3', 'q4'].includes(lastElement.label.toLowerCase().split(' ')[0])) {
      array = generateMonths(lastElement.label, 'quarter')
    } else if (['t1', 't2', 't3'].includes(lastElement.label.toLowerCase().split(' 20')[0])) {
      array = generateMonths(lastElement.label, 'trimester')
    } else if (['h1', 'h2'].includes(lastElement.label.toLowerCase().split(' ')[0])) {
      array = generateMonths(lastElement.label, 'half')
    } else if (
      ['phase1', 'phase2', 'phase3', 'phase4'].includes(
        lastElement.label.toLowerCase().split(' fy')[0].replaceAll(' ', '')
      )
    ) {
      array = generateMonths(lastElement.label, 'phase')
    }

    if (array.length > 0) {
      if (finalData.length === 1 && finalData[0].percent === 0) {
        finalData[0].entryType = 'fakeEntry'
      }
      for (let i = 0; i <= 12 - dataLength - 1; i++) {
        let obj = { v1: 0, v2: 0, v3: 0, v4: 0 }
        if (
          ['SearchDriversProgression3Level', 'DriversProgressionWithoutSentiments3Level'].includes(
            insightsElementType
          )
        ) {
          obj = { v1: 0 }
        }

        const getFakeEntryStr = () => {
          const d = data.filter(f => f.label === array[i])
          return (d?.length) ? 'fakeEntryPastMonth' : 'fakeEntry'
        }

        if(array?.[i]){
          finalData.push({
            ...lastElement,
            fullLabel: array[i],
            label: array[i],
            values: obj,
            percent: 0,
            // entryType: 'fakeEntry',
            entryType: getFakeEntryStr(),
          })
        }
      }
    }

  }

  const barWidthFunc = () => {
    return finalData.length <= 12 ? 40 : 20
  }

  const isNodata = finalData.filter((f) => f.percent > 0).length === 0
  const m1 = data.map((d) => d?.otherDetails?.Percent || 0)
  const m2 = Math.max(...m1)
  const m3 = Math.ceil(m2 / 10) * 10
  let maxValue = m3
  let yAxisTicks = Math.round(maxValue / 10)

  // check 1
  if (maxValue <= 20) {
    yAxisTicks = 4
  }
  if (maxValue <= 10) {
    maxValue = m2 <= 7 ? 8 : 10
    yAxisTicks = m2 <= 8 ? 4 : 5
    if (m2 <= 4) maxValue = 4
  }

  const settings = {
    height: 250,
    width: '100%',
    barWidth: barWidthFunc(),
    margin: { top: 25, right: 0, bottom: 30, left: 30 },
    scaleY: true,
    scaleLineColor: 'transparent',
    scaleTextColor: '#8B8B89',
    customToolTip: 'toolTip2',
    toolTip: true,
    maxValue: maxValue,
    yAxisTicks: yAxisTicks,
    color: [
      LEGEND_COLOR_MAP_NEW.Positive,
      LEGEND_COLOR_MAP_NEW.Neutral,
      LEGEND_COLOR_MAP_NEW.Mixed,
      LEGEND_COLOR_MAP_NEW.Negative,
    ],
  }
  if (['SearchDriversProgression3Level'].includes(insightsElementType)) {
    settings.color = [LEGEND_COLOR_MAP_NEW.SearchKeywords]
  } else if (['DriversProgressionWithoutSentiments3Level'].includes(insightsElementType)) {
    settings.color = [LEGEND_COLOR_MAP_NEW.WithoutSentiments]
  }

  if(keyOrdering.length !== finalData.length && finalData.length > 12){
    const fData = [...keyOrdering].map((d, i) => {
      const arr = finalData.filter(f => f.label === d)
      let obj = { v1: 0, v2: 0, v3: 0, v4: 0 }
      return arr.length === 1 ? arr[0] : {
            fullLabel: d,
            label: d,
            values: obj,
            percent: 0,
            entryType: 'fakeEntryPastMonth',
          }
    })
    finalData = fData.reverse()
  }

  return (
    <StackedGraphWrapper>
      <D3VerticalStacked
        settings={settings}
        data={finalData}
        insightsElementType={insightsElementType}
        showNoDataFound={isNodata}
      />
    </StackedGraphWrapper>
  )
}

const GraphRange = ({ popupDropdownArrayWithAllMonths, selectedObject, onChange }) => {
  const data = popupDropdownArrayWithAllMonths
    .filter(
      (f) =>
        f.drivers === selectedObject?.driverValue &&
        f.attributes === selectedObject?.attributeValue &&
        f.subAttributes === selectedObject?.subAttributeValue
    )
    .map((d) => {
      const dt = new Date(d.otherDetails.CreatedDate.split('T')[0])
      return {
        date: dt.toISOString().split('T')[0],
        value: d.otherDetails.Percent,
        label: d.label,
      }
    })

  const onChangeFunc = (e) => {
    if (e.start !== selectedObject.startDate || e.end !== selectedObject.endDate) {
      onChange(e)
    }
  }

  return (
    <>
      {data?.length > 3 && (
        <D3Range
          rangedata={data.reverse()}
          onChange={onChangeFunc}
          selectedObject={selectedObject}
        />
      )}
    </>
  )
}

const GraphLegend = ({}) => {
  const legendsArray = [
    { label: 'Positive', value: 'Positive' },
    { label: 'Neutral', value: 'Neutral' },
    { label: 'Mixed', value: 'Mixed' },
    { label: 'Negative', value: 'Negative' },
  ]
  return (
    <LegendWrapper>
      <Legend legends={legendsArray} />
    </LegendWrapper>
  )
}
